import { render } from "./DisconnectModal.vue?vue&type=template&id=b03bdc02&scoped=true"
import script from "./DisconnectModal.vue?vue&type=script&lang=js"
export * from "./DisconnectModal.vue?vue&type=script&lang=js"

import "./DisconnectModal.vue?vue&type=style&index=0&id=b03bdc02&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b03bdc02"

export default script